import { PortableTextBlock } from '@portabletext/react';

import VerticalSwiper from 'components/rebrand/VerticalSwiper';

import { ISanityContentCard } from 'typescriptDefs';

type Props = {
  features: ISanityContentCard[];
  heading: PortableTextBlock | PortableTextBlock[];
};

const Features = ({ features, heading }: Props) => {
  return <VerticalSwiper name="home-features" content={features} heading={heading} variant="dangerLight" />;
};

export default Features;
